import React, { useContext, memo } from "react";
import { Typography } from "@mui/material";

import { isYouTubeUrl } from "@/helpers/utils";
import { STATIC_IMAGES } from "@/helpers/staticImages";
import RpVideoPlayer from "@/components/RpVideoPlayer";
import { GlobalContext } from "@/helpers/contexts/contexts";
import { SITE_NAME } from "@/config/appConfig";

interface HowItWorksSetup {
  how_it_work_setup?: string;
  how_it_work_step1?: string;
  how_it_work_step2?: string;
  how_it_work_step3?: string;
  help_video_name?: string;
  video_urls?: string;
}

interface HowItWorksProps {
  pageSetup?: HowItWorksSetup;
}

interface HowItWorksGlobalContext {
  selectedBrand?: {
    brand_name?: string;
  };
}

export default memo(function HowItWorks({ pageSetup }: HowItWorksProps) {
  const {
    how_it_work_setup,
    how_it_work_step1,
    how_it_work_step2,
    how_it_work_step3,
    help_video_name,
    video_urls,
  } = pageSetup || {};

  const { selectedBrand } = useContext(
    GlobalContext
  ) as HowItWorksGlobalContext;

  return (
    <div className="how-it-works-container container">
      <div className="how-it-works my-4 pb-5">
        <div className="card  position-relative">
          <div className="card-body" style={{ padding: "1.25rem .91rem" }}>
            <div className="text-center mb-4">
              <Typography className="heading" component="h2" variant="h3">
                How it Works
              </Typography>
              <Typography
                color="text.primary"
                component="h6"
                className="hiw-heading"
                variant="subtitle1"
              >
                EASY Setup in 3 steps
              </Typography>

              <Typography gutterBottom variant="subtitle2">
                {how_it_work_setup}
              </Typography>
            </div>
            <div>
              <div className="row mb-5">
                <div className="col-md-6 col-lg-7 order-1 order-md-0 pl-0">
                  <img
                    src={`/img/How-It-Works1.png`}
                    alt=""
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
                <div className="col-md-6 col-lg-5 d-flex align-items-center  order-0 order-md-1 position-relative">
                  <img
                    src={STATIC_IMAGES.box_hit_1}
                    alt=""
                    className="img-fluid box_hit_1"
                  />
                  <div className="row steps w-100">
                    <div className="col-2 col-md-12">
                      <div className="count">1</div>
                    </div>
                    <div className="col-10 col-md-12">
                      <h3 className="sub-heading">
                        Contribute your local expertise
                      </h3>
                      <Typography gutterBottom variant="subtitle1">
                        {how_it_work_step1}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-5">
                <div className="col-md-6 col-lg-5 d-flex align-items-center justify-content-md-end position-relative">
                  <img
                    src={STATIC_IMAGES.box_hit_1}
                    alt=""
                    className="img-fluid box_hit_2"
                  />
                  <div className="row text-md-right w-100">
                    <div className="col-2 col-md-12 text-md-right">
                      <div className="count ml-md-auto">2</div>
                    </div>
                    <div className="col-10 col-md-12">
                      <h3 className="sub-heading">Campaigns start</h3>
                      <Typography gutterBottom variant="subtitle1">
                        {how_it_work_step2}
                      </Typography>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-7 pr-0">
                  <img
                    src={`/img/How-It-Works2.png`}
                    alt=""
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 col-lg-7 order-1 order-md-0 pl-0">
                  <img
                    src={`/img/How-It-Works3.png`}
                    alt=""
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
                <div className="col-md-6 col-lg-5 d-flex align-items-center order-0 order-md-1 position-relative">
                  <img
                    src={STATIC_IMAGES.box_hit_1}
                    alt=""
                    className="img-fluid box_hit_3"
                  />
                  <div className="row w-100">
                    <div className="col-2 col-md-12">
                      <div className="count">3</div>
                    </div>
                    <div className="col-10 col-md-12">
                      <h3 className="sub-heading">Get insights</h3>
                      <Typography gutterBottom variant="subtitle1">
                        {how_it_work_step3}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {isYouTubeUrl(video_urls) && (
          <section className="video-section text-center my-5">
            <h2 className="video-heading">
              {help_video_name || "Watch Video Tutorial"} :{" "}
              <span className="hype-name">{SITE_NAME}</span>
              <span> + </span>
              <span className="brand-name">
                {selectedBrand && selectedBrand?.brand_name}
              </span>
            </h2>
            <p className="sub-video-heading">Easy setup in 3 steps</p>
            <div className="row my-5 justify-content-center position-relative">
              <div className="col-md-8 col-lg-6 d-flex-center">
                <img
                  src={STATIC_IMAGES.vid_box_2}
                  alt=""
                  className="img-fluid vid-img-1 d-none d-lg-block d-xl-block"
                />
                <RpVideoPlayer
                  url={video_urls}
                  videoThumbnail={STATIC_IMAGES.videoThumbnail1}
                />
                <img
                  src={STATIC_IMAGES.vid_box_2}
                  alt=""
                  className="img-fluid vid-img-2 d-none d-lg-block d-xl-block"
                />
              </div>
            </div>
          </section>
        )}
      </div>
    </div>
  );
});
